import { LoadingSpinner } from './LoadingSpinner';

interface PageLoadingProps {
  loading: boolean;
  message?: string;
}

/** Renders a centred LoadingSpinner when `loading` is true. */
export function PageLoading({ loading, message }: PageLoadingProps) {
  if (!loading) return null;

  return (
    <div className="flex justify-center py-8">
      <LoadingSpinner message={message} />
    </div>
  );
}
